import { useTranslation } from 'react-i18next'
import { InputGroup } from '@/common'
import { useCallback } from 'react'
import { OrganizationContactDetails } from '@/api/models/OrganizationModel'
import EmailInputGroup from '@/shared/components/EmailInputGroup'

export default function OrganizationContactForm({
  initialState,
  onChange
}: {
  initialState: OrganizationContactDetails
  onChange: (field: { [key: string]: string }) => void
}) {
  const { t } = useTranslation()
  const { contactPhoneNumber, contactEmail, contactFullName, contactRole } = initialState

  const onInputChange = useCallback(
    (evt: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => {
      onChange({ [evt.target.id]: evt.target.value })
    },
    [onChange]
  )
  return (
    <div className="grid grid-cols-2 gap-4">
      <InputGroup
        id="contactFullName"
        label={t('settings:organizationDetails.organizationContact.fields.contactFullName')}
        value={contactFullName}
        onChange={onInputChange}
      />
      <InputGroup
        id="contactRole"
        label={t('settings:organizationDetails.organizationContact.fields.contactRole')}
        value={contactRole}
        onChange={onInputChange}
      />
      <EmailInputGroup
        id="contactEmail"
        label={t('settings:organizationDetails.organizationContact.fields.contactEmail')}
        value={contactEmail}
        onChange={onInputChange}
      />
      <InputGroup
        id="contactPhoneNumber"
        label={t('settings:organizationDetails.organizationContact.fields.contactPhoneNumber')}
        value={contactPhoneNumber}
        onChange={onInputChange}
      />
    </div>
  )
}
